var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongoDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1540_271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1540_271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.3944 32.1442C52.4038 14.5399 44.0865 9.85339 41.9648 6.54053C41.0899 5.08113 40.3148 3.56415 39.645 2C39.5329 3.5639 39.327 4.54916 37.9977 5.73512C35.3286 8.11485 23.9929 17.3523 23.0389 37.3546C22.1501 56.0041 36.7492 67.504 38.678 68.6926C40.1611 69.4224 41.9674 68.7082 42.8484 68.0383C49.8859 63.2085 59.5013 50.3324 56.4022 32.1442",
    fill: "#10AA50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2491 58.7617C39.8816 63.3778 39.6183 66.0599 38.6852 68.6977C38.6852 68.6977 39.2977 73.0923 39.7278 77.7475H41.25C41.6131 74.4693 42.1675 71.2152 42.9103 68.0018C40.9398 67.0321 40.3247 62.8122 40.2491 58.7617Z",
    fill: "#B8C4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9087 68.0043C40.9173 67.0842 40.3413 62.7756 40.2527 58.7616C40.7451 52.1402 40.8887 45.4975 40.6827 38.861C40.5785 35.3787 40.7323 6.6081 39.8252 2.396C40.4457 3.82259 41.1606 5.20624 41.9651 6.53773C44.0868 9.8532 52.4068 14.5397 56.3947 32.144C59.5017 50.3009 49.9384 63.1431 42.9087 68.0043Z",
    fill: "#12924F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoDb);
export default __webpack_public_path__ + "static/media/mongoDB.4e95c4316d3927d6ff38d7908956045c.svg";
export { ForwardRef as ReactComponent };